// context/TransitionContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const TransitionContext = createContext();

export const useTransition = () => {
    const context = useContext(TransitionContext);
    if (!context) {
        throw new Error('useTransition must be used within TransitionProvider');
    }
    return context;
};

export const TransitionProvider = ({ children }) => {
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [targetPath, setTargetPath] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    const startTransition = useCallback((to) => {
        if (to === location.pathname) return;

        setTargetPath(to);
        setIsTransitioning(true);

        // Complete transition after animation
        setTimeout(() => {
            navigate(to);
            setTimeout(() => {
                setIsTransitioning(false);
                setTargetPath(null);
            }, 50);
        }, 600);
    }, [navigate, location.pathname]);

    return (
        <TransitionContext.Provider value={{ startTransition, isTransitioning }}>
            <div className="relative">
                {children}
                <AnimatePresence>
                    {isTransitioning && (
                        <motion.div
                            initial={{ y: '100%' }}
                            animate={{ y: 0 }}
                            exit={{ y: '-100%' }}
                            transition={{
                                duration: 0.8,
                                ease: [0.22, 1, 0.36, 1]
                            }}
                            className="fixed inset-0 z-[1000] flex items-center justify-center page-transition-overlay"
                            style={{ backgroundColor: '#ffffff' }}
                        >
                            <motion.div
                                initial={{ opacity: 0, scale: 0.8 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ delay: 0.2, duration: 0.3 }}
                                className="text-2xl font-bold text-black"
                                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                            >

                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </TransitionContext.Provider>
    );
};